import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSquare, faRss } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faTwitter,
  faYoutube,
  faFlickr,
  faPinterest,
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor() {}
  faSquare = faSquare;
  faFacebookF = faFacebookF;
  faTwitter = faTwitter;
  faYoutube = faYoutube;
  faFlickr = faFlickr;
  faPinterest = faPinterest;
  faRss = faRss;

  ngOnInit() {
    const currYear: any = document.querySelector('.current-year');
    if (currYear) currYear.textContent = new Date().getFullYear();
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
